import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWprocketComponent } from './simple-icons-wprocket.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWprocketComponent ],
    exports:      [ SimpleIconsWprocketComponent ],
    bootstrap:    []
})
export class SimpleIconsWprocketModule {}
